<template>
  <h1 v-if="isLoggedIn" class="title mr-[15px] mt-8 pb-6 md:mt-[45px] md:pb-[64px]">
    Hello, {{ userStore.user?.first_name }}!
  </h1>
  <div v-if="isLoggedIn" class="flex flex-col max-lg:justify-between md:flex-row">
    <div
      class="left_side-wrapper scrollbar-hidden flex-nowrap overflow-x-scroll md:mr-[19.18%] md:overflow-x-visible"
    >
      <button
        @click="newRide"
        type="button"
        class="summary_edit_button m-0 text-nowrap px-[22px] py-[8px] font-bold md:px-[16px] md:py-[8px]"
      >
        Book a New Ride <span class="account__button__disc"></span>
      </button>
      <router-link to="/account/accountinformation" class="account__button text-nowrap"
        >Account Information <span class="account__button__disc"></span
      ></router-link>
      <router-link to="/account/ridehistory" class="account__button text-nowrap"
        >Ride History <span class="account__button__disc"></span
      ></router-link>
      <router-link to="/account/termsofservice" class="account__button text-nowrap"
        >Terms of Service <span class="account__button__disc"></span
      ></router-link>
      <button type="button" class="account__button active text-nowrap">
        Documents/Invoices <span class="account__button__disc"></span>
      </button>
      <router-link
        v-if="isReqAgency || isAgency"
        to="/account/agencyinformation"
        class="account__button text-nowrap"
        >Agency information <span class="account__button__disc"></span
      ></router-link>
      <button v-if="!isMobile" @click="logOut" type="button" class="account__button text-[#878787]">
        Log Out
      </button>
    </div>
    <div v-if="isMobile" class="mt-[6px]">
      <button @click="logOut" type="button" class="account__button text-[#878787]">Log Out</button>
    </div>
    <div class="mt-[25px] text-[20px] md:text-[40px]">Page under the development stage</div>
  </div>
  <h1 v-if="!isLoggedIn" class="title mr-[15px] mt-[5rem]">
    Please login to view account information
  </h1>
  <router-link v-if="!isLoggedIn" to="/account/signin" class="button mt-[15px] w-fit"
    >Sign in</router-link
  >
  <swipe-modal
    v-model="isModal"
    v-if="isMobile"
    contents-height="60vh"
    border-top-radius="16px"
    background-color="ffffff"
    tip-color="#CDCFD0"
  >
    <car-popup-content />
  </swipe-modal>
</template>

<script setup>
import { computed, ref } from 'vue'
import swipeModal from '@takuma-ru/vue-swipe-modal'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useMobile } from '@/compose/ismobile'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import CarPopupContent from '@/components/features/car/CarPopupContent.vue'
import { useOrderStore, useRidesHistoryStore } from '@/stores'

const router = useRouter()
const ridesStore = useRidesHistoryStore()
const userStore = useUserStore()
const orderStore = useOrderStore()
const { isLoggedIn, user } = storeToRefs(userStore)
const isModal = ref(false)

const { isMobile } = useMobile()

const isReqAgency = computed(() => {
  return user.value?.type === 'request for Agency'
})

const isAgency = computed(() => {
  return user.value?.type === 'agency'
})

const newRide = () => {
  orderStore.$reset()
  orderStore.changeTypeOrder('NEW')
  router.push({ name: 'home' })
}

function logOut() {
  ridesStore.$reset()
  userStore.preventLogout()
  setTimeout(function () {
    router.push('/account/signin')
  }, 100)
}

onMounted(() => {})
</script>

<style scoped>
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

.scrollbar-hidden {
  scrollbar-width: none;
}
</style>
